export default __webpack_public_path__ + "static/media/grondplan_nl.94d61c1d.svg";